export const TOGGLE_UNITS = "TOGGLE_UNITS";
export const SET_LOCATION = "SET_LOCATION";
export const SET_CITY = "SET_CITY";